import { Route, Switch, useRouteMatch, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect } from 'react';

import ResetPassword from './pages/reset-password';
import { updateFeedback } from '../reducers';
import Confirm2FA from './pages/confirm-2fa';
import SignIn from './pages/sign-in';
import SignUp from './pages/sign-up';
import Layout from './layout';

const Auth = () => {
  const { feedback } = useSelector((state) => state.auth);
  const { path } = useRouteMatch();
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateFeedback());
  }, [location.pathname]);

  useEffect(() => {
    if (!feedback) return;

    const timeout = setTimeout(() => {
      dispatch(updateFeedback());
    }, 3000);

    return () => clearTimeout(timeout);
  }, [feedback]);

  return (
    <Switch>
      <Layout>
        <Route exact path={`${path}/confirm-2fa/:token`} component={Confirm2FA} />
        <Route exact path={`${path}/reset-password`} component={ResetPassword} />
        <Route exact path={`${path}/sign-up`} component={SignUp} />
        <Route exact path={path} component={SignIn} />
      </Layout>
    </Switch>
  );
};

export default Auth;